import {OnPopupDismissedFn} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {EventHandler} from 'react';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/baseDialog/BaseDialog.less');
const cx = classnames.bind(styles);

export class DialogAction
{
    constructor(public title:string,
                public callback:EventHandler<any>)
    {

    }
}

export enum DialogKind
{
    Modal = 1,
    Popover = 2,
    Alert = 3
}

export enum DialogSize
{
    Dynamic = 0,
    Small = 1,
    Medium = 2,
    Large = 3
}

export class DialogFrameProps
{
    size?:DialogSize;
    title?:string;
    kind?:DialogKind;
    onDismissed?:OnPopupDismissedFn;
    // cancelAction?:DialogAction;
    // primaryAction?:DialogAction;
}

@observer
export class DialogFrame extends React.Component<DialogFrameProps, any>
{
    render()
    {
        let {
            size = DialogSize.Medium,
            kind = DialogKind.Modal,
            title,
            children
        } = this.props;

        return <div className={cx(styles.base, DialogSize[size], DialogKind[kind])}>
            {title && <div className={styles.title}>{title}</div>}
            <div className={cx(styles.content, DialogKind[kind])}>
                {children}
            </div>
        </div>;
    }
}
